import { render, staticRenderFns } from "./App.vue?vue&type=template&id=704b58f2&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=704b58f2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b58f2",
  null
  
)

export default component.exports